import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

Alpine.data('kasirInvitationThemeAnalytics', () => ({
  loading: true,
  analytics: null,

  init() {
    this.load();
  },

  async load() {
    this.loading = true;
    try {
      const { data } = await axios.get('/api/v1/kasir/engagement/invitation-marketplace/analytics');
      this.analytics = data.data || null;
    } catch (e) {
      window.toast?.(e.response?.data?.message || 'Gagal memuat analytics.', 'error');
      this.analytics = null;
    } finally {
      this.loading = false;
    }
  },
}));
